export default "__VITE_ASSET__DAcfrFOa__ 584w";